export const update = {
  updateSuccessfully: 'Update customer successfully!',
}
